import { BaseComponent } from "@symbiotejs/symbiote";
import { RouterAssistant } from "../utilities/router-assistant/router-assistant";
import {MiscAssistant} from "../utilities/misc-assistant/misc-assistant";
import {PwaGuard} from "../components/pwa-guard/pwa-guard";

const beach = require('./assets/beach2.png')
const drinks = require('./assets/cheers.png')
const events = require('./assets/confetti.png')
const food = require('./assets/cooking.png')
const sports = require('./assets/sports2.png')
const theater = require('./assets/theater2.png')

const petros = require('./assets/iakovidis.png')
const feris = require('./assets/feris.png')
const oikonomopoulos = require('./assets/oikonomopoulos.png')
const mavri = require('./assets/mavri.png')
const lefki = require('./assets/lefki.png')
const ifigenia = require('./assets/ifigenia.png')
const paok = require('./assets/paok.png')
const peterson = require('./assets/peterson.png')

const vog = require('./assets/vog.jpg')
const barbarela = require('./assets/barbarela.jpg')
const pyli = require('./assets/pyli.jpg')
const mavri_logo = require('./assets/mavri.jpg')
const lefki_logo = require('./assets/lefki.jpg')
const radiocity = require('./assets/radiocity.jpg')
const toumpa = require('./assets/paokfc.jpg')
const palataki = require('./assets/paokbc.jpg')

const nav_search = require('./assets/search_events.png')
const nav_basket = require('./assets/basket.png')
const nav_tickets = require('./assets/reserved.png')


export class HomeContainer extends BaseComponent {

    initCallback() {
        // window.addEventListener('resize', function () {
        //     // if no resize event is fired within 250ms of the lastly fired one, call the performOrientationChangeActions function :)
        //     MiscAssistant.debounce(HomeContainer.performOrientationChangeActions, 250)
        // }, true)

        RouterAssistant.checkForSingleContainer('home-container', HomeContainer.initiator)
    }


    static initiator() {


        console.log('starting home container')

        if (PwaGuard.accessIsThroughIphone() !== 0) {
            document.getElementById('navigationBar').style.minHeight = '6rem';
        }


        const input = document.getElementById('INPUT_8');
        const element1 = document.getElementById('filtersSection');
        const element2 = document.getElementById('eventsSection');
        const element3 = document.getElementById('searchResults');
        const element4 = document.getElementById('navigationBar');
        const element5 = document.getElementById('backFromSearch');

        input.addEventListener('focus', () => {
            element1.style.display = 'none';
            element2.style.display = 'none';
            element4.style.display = 'none';

            element3.style.display = 'unset';
            element5.style.display = 'flex';

        });

        // input.addEventListener('blur', () => {
        //     element1.style.display = 'block';
        //     element2.style.display = 'grid';
        //     element4.style.display = 'block';
        //
        //     element3.style.display = 'none';
        // });

        input.addEventListener('focusout', (event) => {
            const nextFocusedElement = event.relatedTarget;

            if (nextFocusedElement && nextFocusedElement.tagName.toLowerCase() === 'a') {
                // Clicked on an <a> tag, do nothing
                return;
            }

            // Normal behavior
            element1.style.display = 'block';
            element2.style.display = 'grid';
            element4.style.display = 'block';
            element3.style.display = 'none';
            element5.style.display = 'none';

        });


        input.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                input.value = '';       // clear the input
                input.blur();           // remove focus
                HomeContainer.showEverything()
            }
        });

        setTimeout(() => {
            const swimlaneItems = document.querySelectorAll('.sn-swimlaneItem_06d019');
            const eventItems = document.querySelectorAll('.ikbUXi');


            swimlaneItems.forEach(function (item) {
                item.addEventListener('click', function (event) {
                    const filterValue = item.getAttribute('data-activatefilter');
                    const innerFilterEl = item.querySelector('.sc-irOPRQ');

                    const isActive = innerFilterEl.classList.contains('activeFilter');

                    // Remove activeFilter class from all other sc-irOPRQ elements
                    document.querySelectorAll('.sc-irOPRQ.activeFilter').forEach(function (el) {
                        el.classList.remove('activeFilter');
                    });

                    if (isActive) {
                        // If it was active, we deactivate and show everything
                        innerFilterEl.classList.remove('activeFilter');

                        HomeContainer.showEverything()
                    } else {
                        // Set this one active
                        innerFilterEl.classList.add('activeFilter');

                        // Filter ikbUXi elements
                        document.querySelectorAll('.ikbUXi').forEach(function (el) {
                            const targetFilter = el.getAttribute('data-filters');
                            el.style.display = (targetFilter === filterValue) ? '' : 'none';
                        });
                    }
                });
            });

            HomeContainer.populationOfSearchMap();
            document.getElementById('INPUT_8').addEventListener('input', function () {
                HomeContainer.debounce(HomeContainer.search, 100)
            })
        }, 1500)
    }


    static populationOfSearchMap() {
        let newEventSearchMap = {} // do not break the existing one, assign to window when done
        let counter = 0;
        document.querySelectorAll('.cc-wrapper_86669a').forEach(element => {
            let textOfAllChildren = Array.from(element.children, ({textContent}) => textContent.trim()).filter(Boolean).join('').replace(/ /g, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            textOfAllChildren = MiscAssistant.greek2greeklish(textOfAllChildren);
            console.log(textOfAllChildren)
            newEventSearchMap[counter] = {
                "string": textOfAllChildren,
                "element": element
            }
            counter++;
        })
        window.eventSearchMap = newEventSearchMap;
    }

    static search() {
        let userText = document.getElementById('INPUT_8').value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        userText = MiscAssistant.greek2greeklish(userText);
        if (userText === '')
            HomeContainer.showEverything()
        else
            HomeContainer.showSearchResults(userText)
    }

    static showEverything() {
        document.querySelectorAll('.ikbUXi').forEach(function (el) {
            el.style.display = '';
        });
    }

    static showSearchResults(string) {
        console.log(`activated for ${string}`)
        const stringToSearch = string.replace(/ /g, '').toLowerCase()
        for (const [key, value] of Object.entries(window.eventSearchMap)) {
            if (value['string'].includes(stringToSearch)) {
                console.log(1)
                value['element'].style.display = ''
                console.log(value['element'])
            } else {
                console.log(2)
                value['element'].style.display = 'none'
            }
        }
    }


    static debounce(callback, delay) {
        clearTimeout(window.debounceTimer)
        window.debounceTimer = setTimeout(() => {
            callback();
        }, delay)
    }

}

HomeContainer.template = /*html*/ `
<style>
    *,
    :after,
    :before {
        box-sizing: border-box
    }

    html {
        -webkit-text-size-adjust: 100%
    }

    body {
        margin: 0
    }

    main {
        display: block
    }

    h3 {
        margin: 0
    }

    hr {
        box-sizing: content-box;
        overflow: visible
    }

    a {
        -webkit-text-decoration-skip: objects;
        background-color: transparent;
        text-decoration: none
    }

    a,
    a:hover {
        color: inherit
    }

    a:hover {
        text-decoration: none
    }

    img {
        border-style: none
    }

    button {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0
    }
    
    .sc-irOPRQ{
        padding:5px;
    }
    
    .cc-wrapperContainer .icon-container {
      position: relative;
      display: inline-block; /* shrink‐wrap to icon */
    }
    
    /* 2. Style the badge */
    .cc-badge {
      position: absolute;
      top: -4px;
      left: 15px;
      background-color: #FF3B30;      /* iOS-style red */
      color: #FFFFFF;                /* white text */
      border-radius: 10px;           /* pill shape */
      padding: 0 6px;                /* horizontal padding */
      font-size: 10px;               /* small text */
      font-weight: bold;
      line-height: 18px;             /* vertically center the number */
      min-width: 18px;               /* ensure a circle for 1‐digit */
      text-align: center;
      box-shadow: 0 0 0 1px rgba(0,0,0,0.1); /* subtle border */
    }
    
    .subtext1{
        font-weight: 700;
        color: hsl(0 0% 44%);
        font-size: 0.75rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .subtext2{
        color: hsl(0 0% 44%);
        font-size: 0.75rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .subtext3{
        text-align: right;
        width: 100%;
        font-size: 1.125rem;
        font-weight: 700;
        color: hsl(164 100% 35%);
    }

    button {
        overflow: visible
    }

    button {
        text-transform: none
    }

    button {
        color: var(--color-text-primary)
    }

    [type=button],
    button {
        -webkit-appearance: button
    }

    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit
    }

    html {
        text-size-adjust: 100%;
        -ms-overflow-style: scrollbar;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font-family: sans-serif;
        font-size: 16px;
        line-height: 1.15
    }

    body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--color-text-primary);
        font-family: var(--font-family);
        font-size: var(--font-size-s2);
        font-weight: var(--font-weight-regular);
        line-height: 1.45;
        text-rendering: optimizelegibility
    }

    :root {
        --breakpoint-sm: 576px;
        --breakpoint-md: 768px;
        --breakpoint-lg: 992px;
        --breakpoint-xl: 1200px;
        --breakpoint-xxl: 1400px;
        --container-width-sm: 540px;
        --container-width-md: 720px;
        --container-width-lg: 960px;
        --container-width-xl: 1140px;
        --container-width-xxl: 1320px;
        --font-size-s1: 0.75rem;
        --font-size-s2: 0.875rem;
        --font-size-s3: 1rem;
        --font-size-s4: 1.125rem;
        --font-size-s5: 1.5rem;
        --font-size-s6: 2rem;
        --font-size-s7: 2.5rem;
        --font-size-s8: 3rem;
        --font-family: Averta, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        --font-weight-regular: 400;
        --font-weight-bold: 700;
        --shape-rectangle: 0px;
        --shape-rounded-s0: 2px;
        --shape-rounded-s1: 4px;
        --shape-rounded-s2: 8px;
        --shape-rounded-s3: 12px;
        --shape-rounded-s4: 16px;
        --shape-circle: 50%;
        --shape-pill: 14px;
        --spacing-s1: 0.125rem;
        --spacing-s2: 0.25rem;
        --spacing-s3: 0.5rem;
        --spacing-s4: 1rem;
        --spacing-s5: 1.5rem;
        --spacing-s6: 2rem;
        --spacing-s7: 2.5rem;
        --spacing-s8: 3rem;
        --spacing-s9: 3.5rem;
        --spacing-s10: 4rem;
        --z-index-dropdown: 1000;
        --z-index-fixed: 1030;
        --z-index-drawer: 2000;
        --z-index-modal: 2051;
        --drawer-default-size: 375px
    }

    :root .sonata-light-theme,
    :root [data-theme=sonata-light-theme] {
        --color-blue-h: 215;
        --color-blue-s: 69%;
        --color-blue-l: 49%;
        --color-blue: hsl(var(--color-blue-h) var(--color-blue-s) var(--color-blue-l));
        --color-blue-light-h: 217;
        --color-blue-light-s: 62%;
        --color-blue-light-l: 96%;
        --color-blue-light: hsl(var(--color-blue-light-h) var(--color-blue-light-s) var(--color-blue-light-l));
        --color-green-h: 164;
        --color-green-s: 100%;
        --color-green-l: 35%;
        --color-green: hsl(var(--color-green-h) var(--color-green-s) var(--color-green-l));
        --color-green-light-h: 159;
        --color-green-light-s: 70%;
        --color-green-light-l: 96%;
        --color-green-light: hsl(var(--color-green-light-h) var(--color-green-light-s) var(--color-green-light-l));
        --color-yellow-h: 46;
        --color-yellow-s: 100%;
        --color-yellow-l: 50%;
        --color-yellow: hsl(var(--color-yellow-h) var(--color-yellow-s) var(--color-yellow-l));
        --color-yellow-light-h: 55;
        --color-yellow-light-s: 100%;
        --color-yellow-light-l: 93%;
        --color-yellow-light: hsl(var(--color-yellow-light-h) var(--color-yellow-light-s) var(--color-yellow-light-));
        --color-red-h: 0;
        --color-red-s: 84%;
        --color-red-l: 47%;
        --color-red: hsl(var(--color-red-h) var(--color-red-s) var(--color-red-l));
        --color-red-light-h: 0;
        --color-red-light-s: 75%;
        --color-red-light-l: 97%;
        --color-red-light: hsl(var(--color-red-light-h) var(--color-red-light-s) var(--color-red-light-l));
        --color-black-h: 0;
        --color-black-s: 0%;
        --color-black-l: 8%;
        --color-black: hsl(var(--color-black-h) var(--color-black-s) var(--color-black-l));
        --color-grey-h: 0;
        --color-grey-s: 0%;
        --color-grey-l: 44%;
        --color-grey: hsl(var(--color-grey-h) var(--color-grey-s) var(--color-grey-l));
        --color-grey-light-h: 0;
        --color-grey-light-s: 0%;
        --color-grey-light-l: 67%;
        --color-grey-light: hsl(var(--color-grey-light-h) var(--color-grey-light-s) var(--color-grey-light-l));
        --color-grey-lighter-h: 0;
        --color-grey-lighter-s: 0%;
        --color-grey-lighter-l: 96%;
        --color-grey-lighter: hsl(var(--color-grey-lighter-h) var(--color-grey-lighter-s) var(--color-grey-lighter-l));
        --color-white-h: 0;
        --color-white-s: 0%;
        --color-white-l: 100%;
        --color-white: hsl(var(--color-white-h) var(--color-white-s) var(--color-white-l));
        --color-background-h: var(--color-grey-lighter-h);
        --color-background-s: var(--color-grey-lighter-s);
        --color-background-l: var(--color-grey-lighter-l);
        --color-background: hsl(var(--color-background-h) var(--color-background-s) var(--color-background-l));
        --color-background-secondary-h: var(--color-grey-light-h);
        --color-background-secondary-s: var(--color-grey-light-s);
        --color-background-secondary-l: var(--color-grey-light-l);
        --color-background-secondary: hsl(var(--color-background-secondary-h) var(--color-background-secondary-s) var(--color-background-secondary-l));
        --color-surface-h: var(--color-white-h);
        --color-surface-s: var(--color-white-s);
        --color-surface-l: var(--color-white-l);
        --color-surface: hsl(var(--color-surface-h) var(--color-surface-s) var(--color-surface-l));
        --color-surface-secondary-h: var(--color-black-h);
        --color-surface-secondary-s: var(--color-black-s);
        --color-surface-secondary-l: var(--color-black-l);
        --color-surface-secondary: hsl(var(--color-surface-secondary-h) var(--color-surface-secondary-s) var(--color-surface-secondary-l));
        --color-border-primary-h: var(--color-grey-light-h);
        --color-border-primary-s: var(--color-grey-light-s);
        --color-border-primary-l: var(--color-grey-light-l);
        --color-border-primary: hsl(var(--color-border-primary-h) var(--color-border-primary-s) var(--color-border-primary-l));
        --color-border-secondary-h: var(--color-grey-h);
        --color-border-secondary-s: var(--color-grey-s);
        --color-border-secondary-l: var(--color-grey-l);
        --color-border-secondary: hsl(var(--color-border-secondary-h) var(--color-border-secondary-s) var(--color-border-secondary-l));
        --color-divider-primary-h: var(--color-grey-lighter-h);
        --color-divider-primary-s: var(--color-grey-lighter-s);
        --color-divider-primary-l: var(--color-grey-lighter-l);
        --color-divider-primary: hsl(var(--color-divider-primary-h) var(--color-divider-primary-s) var(--color-divider-primary-l));
        --color-outline-h: var(--color-green-light-h);
        --color-outline-s: var(--color-green-light-s);
        --color-outline-l: var(--color-green-light-l);
        --color-outline: hsl(var(--color-outline-h) var(--color-outline-s) var(--color-outline-l));
        --color-text-primary-h: var(--color-black-h);
        --color-text-primary-s: var(--color-black-s);
        --color-text-primary-l: var(--color-black-l);
        --color-text-primary: hsl(var(--color-text-primary-h) var(--color-text-primary-s) var(--color-text-primary-l));
        --color-text-secondary-h: var(--color-grey-h);
        --color-text-secondary-s: var(--color-grey-s);
        --color-text-secondary-l: var(--color-grey-l);
        --color-text-secondary: hsl(var(--color-text-secondary-h) var(--color-text-secondary-s) var(--color-text-secondary-l));
        --color-text-disabled-h: var(--color-grey-light-h);
        --color-text-disabled-s: var(--color-grey-light-s);
        --color-text-disabled-l: var(--color-grey-light-l);
        --color-text-disabled: hsl(var(--color-text-disabled-h) var(--color-text-disabled-s) var(--color-text-disabled-l));
        --color-success-primary-h: var(--color-green-h);
        --color-success-primary-s: var(--color-green-s);
        --color-success-primary-l: var(--color-green-l);
        --color-success-primary: hsl(var(--color-success-primary-h) var(--color-success-primary-s) var(--color-success-primary-l));
        --color-success-secondary-h: var(--color-green-light-h);
        --color-success-secondary-s: var(--color-green-light-s);
        --color-success-secondary-l: var(--color-green-light-l);
        --color-success-secondary: hsl(var(--color-success-secondary-h) var(--color-success-secondary-s) var(--color-success-secondary-l));
        --color-warning-primary-h: var(--color-yellow-h);
        --color-warning-primary-s: var(--color-yellow-s);
        --color-warning-primary-l: var(--color-yellow-l);
        --color-warning-primary: hsl(var(--color-warning-primary-h) var(--color-warning-primary-s) var(--color-warning-primary-l));
        --color-warning-secondary-h: var(--color-yellow-light-h);
        --color-warning-secondary-s: var(--color-yellow-light-s);
        --color-warning-secondary-l: var(--color-yellow-light-l);
        --color-warning-secondary: hsl(var(--color-warning-secondary-h) var(--color-warning-secondary-s) var(--color-warning-secondary-l));
        --color-error-primary-h: var(--color-red-h);
        --color-error-primary-s: var(--color-red-s);
        --color-error-primary-l: var(--color-red-l);
        --color-error-primary: hsl(var(--color-error-primary-h) var(--color-error-primary-s) var(--color-error-primary-l));
        --color-error-secondary-h: var(--color-red-light-h);
        --color-error-secondary-s: var(--color-red-light-s);
        --color-error-secondary-l: var(--color-red-light-l);
        --color-error-secondary: hsl(var(--color-error-secondary-h) var(--color-error-secondary-s) var(--color-error-secondary-l));
        --color-rating-empty-h: var(--color-grey-h);
        --color-rating-empty-s: var(--color-grey-s);
        --color-rating-empty-l: var(--color-grey-l);
        --color-rating-empty: hsl(var(--color-rating-empty-h) var(--color-rating-empty-s) var(--color-rating-empty-l));
        --color-rating-filled-h: var(--color-green-h);
        --color-rating-filled-s: var(--color-green-s);
        --color-rating-filled-l: var(--color-green-l);
        --color-rating-filled: hsl(var(--color-rating-filled-h) var(--color-rating-filled-s) var(--color-rating-filled-l));
        --color-favourite-filled-h: var(--color-red-h);
        --color-favourite-filled-s: var(--color-red-s);
        --color-favourite-filled-l: var(--color-red-l);
        --color-favourite-filled: hsl(var(--color-favourite-filled-h) var(--color-favourite-filled-s) var(--color-favourite-filled-l));
        --color-favourite-empty-h: var(--color-grey-h);
        --color-favourite-empty-s: var(--color-grey-s);
        --color-favourite-empty-l: var(--color-grey-l);
        --color-favourite-empty: hsl(var(--color-favourite-empty-h) var(--color-favourite-empty-s) var(--color-favourite-empty-l));
        --color-button-primary-h: var(--color-green-h);
        --color-button-primary-s: var(--color-green-s);
        --color-button-primary-l: var(--color-green-l);
        --color-button-primary: hsl(var(--color-button-primary-h) var(--color-button-primary-s) var(--color-button-primary-l));
        --color-button-primary-text-h: var(--color-black-h);
        --color-button-primary-text-s: var(--color-black-s);
        --color-button-primary-text-l: var(--color-black-l);
        --color-button-primary-text: hsl(var(--color-button-primary-text-h) var(--color-button-primary-text-s) var(--color-button-primary-text-l));
        --color-button-outline-h: var(--color-black-h);
        --color-button-outline-s: var(--color-black-s);
        --color-button-outline-l: var(--color-black-l);
        --color-button-outline: hsl(var(--color-button-outline-h) var(--color-button-outline-s) var(--color-button-outline-l));
        --color-button-outline-text-h: var(--color-black-h);
        --color-button-outline-text-s: var(--color-black-s);
        --color-button-outline-text-l: var(--color-black-l);
        --color-button-outline-text: hsl(var(--color-button-outline-text-h) var(--color-button-outline-text-s) var(--color-button-outline-text-l));
        --color-button-outline-secondary-h: var(--color-white-h);
        --color-button-outline-secondary-s: var(--color-white-s);
        --color-button-outline-secondary-l: var(--color-white-l);
        --color-button-outline-secondary: hsl(var(--color-button-outline-secondary-h) var(--color-button-outline-secondary-s) var(--color-button-outline-secondary-l));
        --color-button-outline-secondary-text-h: var(--color-white-h);
        --color-button-outline-secondary-text-s: var(--color-white-s);
        --color-button-outline-secondary-text-l: var(--color-white-l);
        --color-button-outline-secondary-text: hsl(var(--color-button-outline-secondary-text-h) var(--color-button-outline-secondary-text-s) var(--color-button-outline-secondary-text-l));
        --color-button-secondary-h: var(--color-grey-lighter-h);
        --color-button-secondary-s: var(--color-grey-lighter-s);
        --color-button-secondary-l: var(--color-grey-lighter-l);
        --color-button-secondary: hsl(var(--color-button-secondary-h) var(--color-button-secondary-s) var(--color-button-secondary-l));
        --color-button-secondary-text-h: var(--color-black-h);
        --color-button-secondary-text-s: var(--color-black-s);
        --color-button-secondary-text-l: var(--color-black-l);
        --color-button-secondary-text: hsl(var(--color-button-secondary-text-h) var(--color-button-secondary-text-s) var(--color-button-secondary-text-l));
        --color-button-tertiary-h: var(--color-black-h);
        --color-button-tertiary-s: var(--color-black-s);
        --color-button-tertiary-l: var(--color-black-l);
        --color-button-tertiary: hsl(var(--color-button-tertiary-h) var(--color-button-tertiary-s) var(--color-button-tertiary-l));
        --color-button-tertiary-text-h: var(--color-white-h);
        --color-button-tertiary-text-s: var(--color-white-s);
        --color-button-tertiary-text-l: var(--color-white-l);
        --color-button-tertiary-text: hsl(var(--color-button-tertiary-text-h) var(--color-button-tertiary-text-s) var(--color-button-tertiary-text-l));
        --color-button-white-h: var(--color-white-h);
        --color-button-white-s: var(--color-white-s);
        --color-button-white-l: var(--color-white-l);
        --color-button-white: hsl(var(--color-button-white-h) var(--color-button-white-s) var(--color-button-white-l));
        --color-button-white-text-h: var(--color-black-h);
        --color-button-white-text-s: var(--color-black-s);
        --color-button-white-text-l: var(--color-black-l);
        --color-button-white-text: hsl(var(--color-button-white-text-h) var(--color-button-white-text-s) var(--color-button-white-text-l))
    }

    @keyframes sn-spin {
        0% {
            transform: rotate(0deg)
        }

        to {
            transform: rotate(1turn)
        }
    }

    @keyframes sn-pulse {
        0% {
            opacity: 1
        }

        50% {
            opacity: .6
        }

        to {
            opacity: 1
        }
    }

    @keyframes sn-fade {
        0% {
            opacity: 0
        }

        to {
            opacity: 1
        }
    }

    @keyframes sn-slide-top-full {
        0% {
            transform: translateY(-100%)
        }

        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-bottom-full {
        0% {
            transform: translateY(100%)
        }

        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-left-full {
        0% {
            transform: translateX(-100%)
        }

        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-right-full {
        0% {
            transform: translateX(100%)
        }

        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-across-x {
        0% {
            transform: translateX(-100%)
        }

        to {
            transform: translateX(100%)
        }
    }

    @keyframes sn-slide-across-y {
        0% {
            transform: translateY(-100%)
        }

        to {
            transform: translateY(100%)
        }
    }

    .sn-box-shadow-light {
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .04)
    }

    .sn-overflow-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }

    .sn-line-clamp1 {
        -webkit-line-clamp: 1
    }

    .sn-line-clamp1 {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden
    }

    .sn-reset-list {
        list-style-type: none;
        margin: 0;
        padding: 0
    }

    .sn-reset-button {
        background: none;
        outline: 0;
        padding: 0
    }

    .cc-wrapper_a89bdd {
        align-items: stretch;
        background-color: var(--color-surface);
        display: flex;
        flex-direction: column;
        min-height: 96px
    }

    .cc-appDownloadWrapper_375259 {
        display: flex;
        flex-direction: column;
        padding-top: var(--spacing-s5)
    }


    .cc-horizontalRule_6a6d70 {
        border: 0;
        box-shadow: 0 1px 1px var(--color-border-primary);
        height: 1px;
        margin: 0;
        margin-left: calc(var(--spacing-s4)*-1);
        padding: 0;
        padding-right: var(--spacing-s6);
        width: 100%
    }

    .cc-socialTitle_3c55e2 {
        color: var(--color-text-secondary);
        display: inline-block;
        text-align: center
    }


    .cc-socialWrapper_fcb6ef {
        display: flex;
        justify-content: center;
        list-style: none;
        padding: 0
    }


    .cc-socialIcon_2a0e69 {
        color: var(--color-text-secondary);
        margin-left: var(--spacing-s4)
    }

    .cc-socialIcon_2a0e69:first-child {
        margin-left: 0
    }


    .cc-backToTop_c2dd44 {
        color: var(--color-text-secondary);
        display: flex;
        flex-direction: column;
        font-weight: var(--font-weight-bold);
        height: 150px;
        padding: var(--spacing-s5);
        text-align: center
    }

    .cc-right_a13620 {
        align-items: flex-end
    }


    .cc-arrowTop_16198b {
        align-items: center;
        border: 1px solid var(--color-background-secondary);
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 40px
    }


    .cc-logoLink_2f640d {
        text-align: center
    }


    .cc-logo_d90b40 {
        width: 184px
    }


    .cc-storeWrapper_b6e2a4 {
        display: inline-block;
        margin: 0 auto
    }


    .cc-storeItem_c3503c {
        display: inline-block;
        margin-right: var(--spacing-s3);
        margin-top: var(--spacing-s3)
    }

    .cc-title_f05dd2 {
        font-size: var(--font-size-s5);
        font-weight: var(--font-weight-bold);
        margin-bottom: 0;
        margin-top: 0
    }

    .cc-subtitle_e6101a {
        color: var(--color-text-secondary);
        margin: 0;
        max-width: 495px
    }

    .sn-list_ca48e4 {
        display: flex;
        flex-wrap: nowrap;
        padding-block: var(--spacing-s4)
    }

    .sn-item_cfffb2 {
        font-size: var(--font-size-s1)
    }

    .sn-item_cfffb2:not(:first-child) {
        margin-left: var(--spacing-s3)
    }

    .sn-item_cfffb2:not(:first-child):before {
        content: "›";
        padding-right: var(--spacing-s3)
    }

    .sn-link_786139 {
        color: var(--color-text-secondary);
        text-decoration: none
    }

    .sn-link_786139.sn-active_95ff47 {
        color: var(--color-text-primary);
        font-weight: var(--font-weight-bold)
    }

    @keyframes cc-pulseAnimation_a2faaa {
        0% {
            transform: scale(1) rotate(0deg)
        }

        25% {
            transform: scale(.85) rotate(12deg)
        }

        50% {
            transform: scale(.65) rotate(18deg)
        }

        75% {
            transform: scale(1.06) rotate(8deg)
        }

        to {
            transform: scale(1) rotate(0deg)
        }
    }

    :root .sonata-dark-theme,
    :root .sonata-light-theme,
    :root [data-theme=sonata-dark-theme],
    :root [data-theme=sonata-light-theme] {
        --color-backdrop-h: var(--color-black-h);
        --color-backdrop-s: var(--color-black-s);
        --color-backdrop-l: var(--color-black-l);
        --color-backdrop: hsl(var(--color-backdrop-h) var(--color-backdrop-s) var(--color-backdrop-l))
    }

    @keyframes sn-slide-top-drawer_031d93 {
        0% {
            transform: translateY(calc(var(--drawer-default-size)*-1))
        }

        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-bottom-drawer_a5f183 {
        0% {
            transform: translateY(100%)
        }

        to {
            transform: translateY(calc(100% - var(--drawer-default-size)))
        }
    }

    @keyframes sn-slide-left-drawer_a6b2d7 {
        0% {
            transform: translateX(calc(var(--drawer-default-size)*-1))
        }

        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-right-drawer_874c6f {
        0% {
            transform: translateX(100%)
        }

        to {
            transform: translateX(calc(100% - var(--drawer-default-size)))
        }
    }

    .sn-base_164c44 {
        appearance: none !important;
        border-radius: var(--shape-rounded-s2);
        display: inline-block;
        font-size: var(--font-size-s2);
        font-weight: var(--font-weight-bold);
        line-height: 1.5;
        padding: var(--spacing-s4);
        text-align: center;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
        user-select: none;
        vertical-align: middle;
        white-space: nowrap
    }

    .sn-base_164c44:hover {
        text-decoration: none
    }

    .sn-base_164c44:active,
    .sn-base_164c44:focus {
        box-shadow: 0 0 0 .2rem var(--color-outline);
        outline: 0;
        text-decoration: none
    }

    .sn-base_164c44.sn-disabled_c5a2fb,
    .sn-base_164c44:disabled {
        box-shadow: none;
        opacity: .65;
        text-decoration: none
    }

    .sn-base_164c44:not(:disabled) {
        cursor: pointer
    }

    .sn-secondary_763df0 {
        background-color: var(--color-button-secondary);
        border: var(--color-button-secondary);
        color: var(--color-button-secondary-text)
    }

    .sn-secondary_763df0:hover {
        background-color: hsl(var(--color-button-secondary-h), var(--color-button-secondary-s), calc(var(--color-button-secondary-l) - 4%));
        color: var(--color-button-secondary-text)
    }

    @keyframes cc-pulseAnimation_b42778 {
        0% {
            transform: scale(1) rotate(0deg)
        }

        25% {
            transform: scale(.85) rotate(12deg)
        }

        50% {
            transform: scale(.65) rotate(18deg)
        }

        75% {
            transform: scale(1.06) rotate(8deg)
        }

        to {
            transform: scale(1) rotate(0deg)
        }
    }


    .sn-appContainer_9e3a25 {
        z-index: 100
    }

    .sn-layersContainer_864281 {
        z-index: 1000
    }

    .sn-container_ea7a7d {
        margin-left: auto;
        margin-right: auto;
        padding-left: var(--spacing-s4);
        padding-right: var(--spacing-s4);
        width: 100%
    }


    @keyframes sn-bounce-swipeable-stack_f3bf03 {

        0%,
        20%,
        50%,
        80%,
        to {
            transform: translateX(0)
        }

        40% {
            transform: translateX(-72px)
        }

        60% {
            transform: translateX(-36px)
        }
    }


    .cc-wrapper_9babfd {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;
        margin: 0 var(--spacing-s2);
        min-width: 0;
        padding: 0 var(--spacing-s3);
        position: relative
    }

    .cc-wrapper_9babfd:hover {
        cursor: pointer
    }

    .cc-label_b4f792 {
        font-size: var(--font-size-s1);
        max-width: 100%
    }

    .cc-navigationIcon_763ff2 {
        height: 1.4rem;
        margin-top: 0.5rem;
        width: 1.4rem;
    }

    .cc-label_b4f792,
    .cc-navigationIcon_763ff2 {
        color: var(--color-text-secondary)
    }

    .cc-wrapperActive_669bbb .cc-label_b4f792,
    .cc-wrapperActive_669bbb .cc-navigationIcon_763ff2 {
        color: var(--color-surface-secondary)
    }

    .cc-wrapper_9babfd:after {
        background-color: transparent;
        border: var(--spacing-s1) solid transparent;
        border-radius: var(--shape-rounded-s0);
        content: "";
        left: 0;
        position: absolute;
        top: 0;
        width: 100%
    }

    .cc-wrapperActive_669bbb:after {
        background-color: var(--color-surface-secondary);
        border-color: var(--color-surface-secondary)
    }

    .cc-wrapper_f06cbe {
        background-color: var(--color-surface);
        box-shadow: 0-2px 4px 0 rgba(0, 0, 0, .08);
        height: var(--spacing-s10)
    }

    .cc-wrapper_f06cbe {
        align-items: center;
        display: flex;
        justify-content: center
    }


    @keyframes sn-slideUpSmall_b6d058 {
        0% {
            transform: translateY(10%)
        }

        to {
            transform: translateY(0)
        }
    }

    :root .sonata-light-theme,
    :root [data-theme=sonata-light-theme] {
        --color-background-rating-h: var(--color-green-light-h);
        --color-background-rating-s: var(--color-green-light-s);
        --color-background-rating-l: var(--color-green-light-l);
        --color-background-rating: hsl(var(--color-background-rating-h) var(--color-background-rating-s) var(--color-background-rating-l))
    }


    .sn-wrapper_6ebea0 {
        border-radius: var(--shape-rounded-s2)
    }

    .sn-wrapper_6ebea0 {
        display: inline-block;
        padding: var(--spacing-s1) var(--spacing-s3);
        text-align: center;
        white-space: nowrap
    }

    .sn-transparent_4bdae1:first-child {
        padding-inline-start: 0
    }

    .sn-title_d35a2f {
        font-size: var(--font-size-s1);
        font-weight: var(--font-weight-bold);
        white-space: nowrap
    }

    .sn-image_5935b2 {
        display: inline-block;
        margin-right: var(--spacing-s2);
        vertical-align: middle
    }

    .sn-swimlaneWrapper_f8f9ed {
        position: relative;
        width: 100%
    }

    .sn-swimlaneWrapper_f8f9ed.sn-allowOverflow_f60cf1 {
        cursor: default;
        overflow: auto
    }

    .sn-itemList_f16527 {
        gap: 0.4rem;
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        position: relative;
        transition: transform .35s ease-out;
        width: 100%;
        z-index: 0
    }

    .sn-swimlaneItem_06d019 {
        flex-shrink: 0;
        overflow: hidden;
    }

    .sn-swimlaneItem_06d019:hover {
        cursor: pointer;
        transform: scale(1.05);
        /* Slight zoom-in by 5% */
        transition: transform 0.3s ease;
        /* Optional: smooth transition */
    }


    .cc-wrapper_4b9eba {
        align-items: center;
        display: inline-flex;
        text-align: center;
        white-space: nowrap
    }

    .cc-image_0240e3 {
        display: inline-block;
        vertical-align: middle;
        width: auto
    }

    .cc-logoWrapper_0e1a90 {
        position: relative
    }

    .cc-image_a03f68 {
        background: var(--color-text-secondary);
        border-radius: var(--shape-circle);
        display: inline-block
    }

    .cc-image_a03f68.cc-withBorder_7acef6 {
        border: 1px solid var(--color-text-secondary)
    }

    .cc-wrapper_de1daf {
        background: var(--color-surface)
    }

    .cc-wrapper_de1daf.cc-image_35061e {
        border-radius: var(--shape-rounded-s2);
        margin: 0
    }

    .cc-inner_a8a37d {
        color: var(--color-text-primary);
        display: flex;
        flex-direction: column;
        min-height: 100%;
        position: relative;
        text-decoration: none
    }

    .cc-deliveryCost_e902e7 {
        align-items: center;
        background-color: white;
        border-top-left-radius: var(--shape-rounded-s2);
        border-top-right-radius: var(--shape-rounded-s2);
        bottom: 0;
        display: flex;
        padding: var(--spacing-s2) var(--spacing-s3)0 var(--spacing-s3);
        position: absolute;
        right: 8px
    }

    .cc-deliveryCost_e902e7 svg {
        margin-right: var(--spacing-s2);
        width: 14px
    }

    .cc-shopIconBadge_fc088d {
        left: var(--spacing-s3);
        position: absolute;
        top: var(--spacing-s3);
        z-index: 1
    }

    .cc-imageCoverWrapper_7d776f {
        border-top-left-radius: var(--shape-rounded-s2);
        border-top-right-radius: var(--shape-rounded-s2);
        flex: 0 0 174px;
        height: 174px;
        overflow: hidden;
        position: relative;
        width: 100%
    }

    .cc-cover_e519a2 {
        border-radius: var(--shape-rounded-s2) var(--shape-rounded-s2)0 0;
        height: 100%;
        object-fit: cover;
        object-position: center;
        width: 100%;
        padding-bottom: 1px;
    }

    .cc-coverLogo_d994c0 {
        bottom: var(--spacing-s3);
        left: var(--spacing-s3);
        position: absolute
    }

    .cc-coverBadgesWrapper_c18dc6 {
        position: absolute;
        right: var(--spacing-s3);
        top: var(--spacing-s3)
    }

    .cc-coverBadgesWrapper_c18dc6,
    .cc-shopAdBadge_c4c301 {
        align-items: center;
        display: flex;
        justify-content: center;
        z-index: 1
    }

    .cc-shopAdBadge_c4c301 {
        background: rgba(0, 0, 0, .15);
        border-radius: var(--shape-circle);
        color: var(--color-surface);
        cursor: pointer;
        font-size: var(--font-size-s1);
        padding: var(--spacing-s2);
        width: 26px
    }

    .cc-shopItemWrapper_4ce69c {
        background: var(--color-surface);
        display: flex;
        justify-content: flex-start;
        width: 100%
    }

    .cc-shopItemWrapper_4ce69c.cc-image_35061e {
        border-bottom-left-radius: var(--shape-rounded-s2);
        border-bottom-right-radius: var(--shape-rounded-s2);
        min-height: 84px;
        padding-bottom: var(--spacing-s3);
        padding-top: var(--spacing-s3)
    }

    .cc-infoWrapper_73e83c {
        display: flex;
        flex: 1;
        min-width: 0;
        padding-left: var(--spacing-s3);
        padding-right: var(--spacing-s3)
    }

    .cc-info_27ca9b {
        background: var(--color-surface);
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0
    }

    .cc-title_6a7783 {
        margin-bottom: 0;
        margin-top: 0
    }

    .cc-deliveryCostPrice_6cf03d {
        margin-left: 0
    }

    .cc-listContextInfoItem_71f608 {
        font-size: var(--font-size-s1);
        white-space: nowrap
    }

    .hasBullet:before
    {
        color: var(--color-text-secondary);
        content: "•";
        display: inline-block;
        margin: 0 var(--spacing-s2)
    }


    .cc-listContextInfo_6a2af4 {
        color: var(--color-text-secondary);
        display: block;
        font-size: var(--font-size-s1);
        min-width: 0
    }

    .cc-listContextInfo_6a2af4.cc-image_35061e .cc-listContextInfoItem_71f608 {
        display: inline-flex;
        flex-shrink: 0
    }

    .cc-listContextInfo_6a2af4.cc-image_35061e .cc-listContextInfoCategoryItem_92ed91 {
        flex-shrink: 1;
        font-weight: var(--font-weight-bold);
        max-width: 110px
    }

    .cc-badges_e821ed {
        margin-top: var(--spacing-s1)
    }

    .cc-ratingWrapper_239e98 {
        width:6rem;
        align-items: flex-end;
        display: flex;
        flex: 0 0 45px;
        flex-direction: column;
        justify-content: center;
        padding-right: var(--spacing-s3)
    }

    .cc-rating_735e91 {
        align-items: center;
        color: var(--color-rating-filled);
        display: flex;
        height: 24px;
        width: 130px;
    }

    .cc-ratingAverage_78d3f9 {
        font-size: var(--font-size-s4);
        font-weight: var(--font-weight-bold);
        margin-left: var(--spacing-s1);
        width:100%
    }

    .cc-ratingIcon_639b83 {
        color: var(--color-rating-filled);
        height: 14px;
        width: 14px
    }

    .cc-ratingAmount_e3964f {
        color: var(--color-text-secondary);
        font-size: var(--font-size-s1)
    }


    .cc-wrapper_9e8bc6 {
        align-items: center;
        display: inline-flex;
        justify-content: center
    }

    .cc-ratingAverage_e8e48b {
        font-weight: var(--font-weight-bold)
    }

    .cc-ratingAmount_4c999f {
        color: var(--color-text-secondary);
        font-size: var(--font-size-s1)
    }

    .cc-horizontal_a399de {
        flex-direction: row
    }

    .cc-horizontal_a399de .cc-ratingAmount_4c999f,
    .cc-horizontal_a399de .cc-ratingAverage_e8e48b {
        margin-left: var(--spacing-s2)
    }

    .cc-small_565443 .cc-ratingAverage_e8e48b {
        font-size: var(--font-size-s1)
    }

    .cc-rating_2afa85 {
        align-items: center;
        color: var(--color-rating-filled);
        display: flex
    }

    .cc-ratingIcon_725f44 {
        color: var(--color-rating-filled);
        height: 14px;
        width: 14px
    }

    .cc-wrapper_401125 {
        background: var(--color-surface);
        border-radius: var(--shape-rounded-s2);
        display: flex;
        height: 100%
    }

    .cc-inner_fbdc02 {
        position: relative;
        width: 100%
    }

    .cc-imageCoverWrapper_129ac8 {
        border-top-left-radius: var(--shape-rounded-s2);
        border-top-right-radius: var(--shape-rounded-s2);
        height: 141px;
        overflow: hidden;
        position: relative;
        width: 100%
    }

    .cc-cover_ae43b4 {
        border-radius: var(--shape-rounded-s2) var(--shape-rounded-s2)0 0;
        height: 141px;
        object-fit: cover;
        width: 100%
    }

    .cc-details_6fac82 {
        padding: var(--spacing-s2) var(--spacing-s3) var(--spacing-s4)
    }

    .cc-title_74752d {
        color: var(--color-text-primary);
        font-size: var(--font-size-s2);
        font-weight: var(--font-weight-bold);
        height: var(--spacing-s4);
        line-height: var(--spacing-s4);
        margin: 0 0 var(--spacing-s3)
    }

    .cc-ratingCategoryWrapper_f47c67 {
        display: flex
    }

    .cc-ratingSummary_14221a {
        margin-bottom: var(--spacing-s2)
    }

    .cc-category_7f34d4 {
        font-weight: var(--font-weight-bold);
        margin: 0 var(--spacing-s2)0
    }

    .cc-category_7f34d4,
    .cc-infoWrapper_4325ac {
        color: var(--color-text-secondary);
        font-size: var(--font-size-s1)
    }

    .cc-infoWrapper_4325ac {
        margin: 0
    }

    .cc-shopIconBadge_0b45b0 {
        left: var(--spacing-s3);
        position: absolute;
        top: var(--spacing-s3);
        z-index: 1
    }

    .cc-deliveryCost_db77f6 {
        align-items: center;
        background: var(--color-surface);
        border-top-left-radius: var(--shape-rounded-s2);
        border-top-right-radius: var(--shape-rounded-s2);
        bottom: 0;
        display: flex;
        padding: var(--spacing-s2) var(--spacing-s3)0 var(--spacing-s3);
        position: absolute;
        right: 0
    }

    .cc-deliveryCost_db77f6 svg {
        margin-right: var(--spacing-s2);
        width: 14px
    }

    .cc-deliveryCostPrice_86683b {
        margin-left: 0
    }

    .cc-listContextInfoItem_7b7212 {
        font-size: var(--font-size-s1);
        white-space: nowrap
    }

    .cc-listContextInfoItem_7b7212.cc-image_82da78:not(:first-child):before,
    .cc-listContextInfoItem_7b7212.cc-list_61cacd:not(:first-child):before {
        color: var(--color-text-secondary);
        content: "•";
        display: inline-block;
        margin: 0 var(--spacing-s2)
    }


    :root .sonata-light-theme,
    :root [data-theme=sonata-light-theme] {
        --color-background-skeleton-h: var(--color-grey-light-h);
        --color-background-skeleton-s: var(--color-grey-light-s);
        --color-background-skeleton-l: var(--color-grey-light-l);
        --color-background-skeleton: hsl(var(--color-background-skeleton-h) var(--color-background-skeleton-s) var(--color-background-skeleton-l))
    }

    .cc-wrapper_129841 {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--spacing-s4);
        width: 100%
    }

    .cc-title_7885eb {
        font-size: var(--font-size-s4);
        margin: 0
    }


    <style data-styled="active" data-styled-version="6.1.1">.fXuPVX {
        margin: 0px;
        color: rgb(20, 20, 20);
        font-weight: 700;
        font-size: 1.125rem;
        text-align: left
    }

    .gmSNZM {
        position: relative
    }

    .gmSNZM+.gmSNZM::before {
        content: none
    }


    .fKbLeB {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 8px 0px;
        cursor: pointer;
        width: 156px;
        height: 225px
    }


    .kGktPM {
        display: flex;
        width: 100%;
        height: 100%;
        border-radius: 8px
    }

    .vDPJd {
        margin-left: -1rem;
        margin-right: -1rem;
        width: auto
    }


    .heqGeJ>div {
        align-items: stretch
    }

    /*.heqGeJ>div>:first-child>div {*/
    /*    padding-left: 1rem*/
    /*}*/


    .zZKgo {
        /*margin-right: 1rem;*/
        box-sizing: content-box;
        display: inline-block
    }

    .dRZDHl {
        text-decoration: underline;
        display: flex;
        gap: 0.25rem;
        align-items: center;
        justify-content: center;
        padding-top: 1rem;
        color: rgb(112, 112, 112);
        font-weight: 700
    }

    .dRZDHl:hover {
        color: rgb(112, 112, 112)
    }


    .cnqPaq {
        padding-top: 1rem
    }

    .eQjmkg {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 1rem
    }

    .kqYbVf {
        background-color: rgb(244, 244, 244);
        border: 2px solid rgb(255, 255, 255);
        display: flex;
        border-radius: 4px
    }

    .ggqKgy {
        cursor: pointer;
        padding: 0.25rem 0.5rem;
        margin: 0.125rem;
        border-radius: 4px;
        color: rgb(112, 112, 112)
    }

    .kuoFGm {
        cursor: pointer;
        padding: 0.25rem 0.5rem;
        margin: 0.125rem;
        border-radius: 4px;
        background-color: rgb(255, 255, 255);
        color: rgb(20, 20, 20)
    }

    .ikbUXi {
        max-width: 24rem;
        position: relative;
        display: inline-block;
        width: 100%;
        margin-bottom: 1rem;
        box-shadow: rgba(0, 0, 0, 0.08) 4px 4px 16px 0px;
        border-radius: 8px
    }

    .ikbUXi:hover {
        transform: scale(1.01);
        /* Slight zoom-in by 5% */
        transition: transform 0.3s ease;
        /* Optional: smooth transition */
    }


    /*
    .ikbUXi:first-of-type::before {
        content: none
    }
    */


    .hgGyUo {
        width: 236px
    }

    .kbYcCi {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 3.5rem;
        padding: 2rem
    }

    .hYykqE {
        text-align: center;
        font-size: 1.125rem;
        font-weight: 700
    }

    .japlfM {
        text-align: center;
        color: rgb(112, 112, 112);
        font-size: 1rem;
        margin-top: 0.25rem
    }

    .goGeSy {
        margin-top: 1.5rem;
        max-width: 343px;
        width: 100%
    }

    .VZxZI {
        margin-left: -1rem;
        padding-left: 1rem;
        width: auto
    }

    .iAmeEL {
        position: relative;
        width: calc(100% + 16px)
    }


    .fMnjzf {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%
    }

    .ffmVDa {
        font-size: 1.125rem;
        margin: 0px 0px 1rem 0.25rem
    }


    .bNkGMW {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        font-size: 12px;
        line-height: 1;
        color: rgb(20, 20, 20);
        outline: none;
        cursor: pointer;
        margin: 0px
    }

    .bNkGMW:focus {
        outline: none
    }


    .cnLkjA {
        color: rgb(20, 20, 20);
        height: 10px;
        width: 10px;
        margin: -2px 0px 0px 5px
    }

    .dpEKld {
        overflow: hidden;
        position: relative;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 8px 0px;
        height: 230px;
        width: 149px;
        cursor: pointer;
        margin-right: 1rem
    }

    .imWhyk {
        overflow: hidden;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 100%
    }

    .imWhyk img {
        object-fit: cover;
        height: 100%;
        width: 100%
    }

    .imWhyk::before {
        content: "";
        display: block;
        position: absolute;
        inset: 0px;
        opacity: 0.4;
        mix-blend-mode: multiply;
        background-image: linear-gradient(rgb(238, 238, 238) 54%, rgb(0, 0, 0))
    }

    .dnozoK {
        position: absolute;
        top: 8px;
        left: 8px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgb(247, 247, 247);
        border-radius: 50%;
        background-color: rgb(247, 247, 247);
        overflow: hidden
    }

    .dnozoK img {
        border-radius: 50%;
        object-fit: cover;
        height: 100%;
        width: 100%
    }

    .jlFcJu {
        position: absolute;
        bottom: 8px;
        left: 8px
    }

    .losAXD {
        color: rgb(255, 255, 255);
        font-size: 14px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin: 0px
    }

    .XSnyF {
        color: rgb(255, 255, 255);
        font-size: 14px;
        font-weight: normal;
        margin: 0px
    }

    .fsIyEp {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative
    }

    .activeFilter {
        background: linear-gradient(45deg, #ffffff, #4ad2ff);
        color: white;
        border-radius: 6px;
    }

    .eNAoZg {
        width: 40px;
        height: 40px;
        object-fit: contain
    }

    .gDBVxO {
        font-size: 0.75rem;
        color: rgb(112, 112, 112);
        text-overflow: ellipsis;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-align: center
    }

    #smartbanner-container {
        z-index: 1031;
        position: absolute;
        width: 100%;
        overflow: hidden
    }

    #smartbanner-container:has(div)+* {
        z-index: 1;
        padding-top: 90px
    }


    img.lazyload {
        opacity: 0
    }

    img.lazyloaded {
        opacity: 1;
        transition: opacity 0.2s ease-in
    }

    .blurhash-image {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%
    }

    img.lazyloaded:not(.shops-listing-shop-logo)~.blurhash-image {
        opacity: 0;
        transition: opacity 0.3s ease-in
    }

    .eAVXSn {
        display: flex;
        flex-direction: column;
        position: relative;
        margin-top: 0px;
        min-height: calc(-64px + 100vh);
        background-color: rgb(255, 255, 255);
        padding-left: calc(-100% + 100vw)
    }


    .kOhGFy {
        display: flex;
        padding: 0px
    }


    .GRIZp {
        display: flex;
        flex-direction: column;
        flex: 0 0 100%;
        max-width: 100%;
        margin: 0px auto;
        padding: 0px 1rem 10rem
    }


    .conWMH {
        width: 100%;
        position: fixed;
        bottom: 0px;
        left: 0px;
        animation: 0.3s ease-in-out 0s 1 normal none running crmfwB;
        padding-bottom: env(safe-area-inset-bottom);
        background-color: rgb(255, 255, 255);
        z-index: 1030
    }

    .swimlane-1-0-component,
    .list-1-0-component,
    .stories-1-0-component,
    .header-1-0-action,
    .header-1-0-toggle {
        margin-top: 14px
    }

    .swimlane-1-0-component .banner-2-0-image {
        margin-block: 0px
    }

    .multiple_order-1-0-component:first-child,
    .order-1-0-component:first-child,
    .swimlane-1-0-component:first-child,
    .list-1-0-component:first-child,
    .stories-1-0-component:first-child,
    .header-1-0-info:first-child {
        margin-top: 0px
    }

    .header-1-0-action+.swimlane-1-0-component {
        margin-top: 16px
    }

    @keyframes crmfwB {
        0% {
            transform: translateY(100%)
        }

        100% {
            transform: translateY(calc(100% - 64px))
        }
    }
</style>
    <div class="sn-appContainer_9e3a25">
    	<div class="sc-bgXrwt eAVXSn">
    		<div class="sn-container_ea7a7d sc-erjZAe kOhGFy">
    			<div class="sc-eoseYw GRIZp">
    				<div class="sc-eishYz shop_list-1-0-component">
    					<div id="searchContainer" style="margin-top: 1rem;align-items: center;block-size: 48px;border-block-end-color: rgb(20, 20, 20);border-block-start-color: rgb(20, 20, 20);border-end-end-radius: 8px;border-end-start-radius: 8px;border-inline-end-color: rgb(20, 20, 20);border-inline-start-color: rgb(20, 20, 20);border-start-end-radius: 8px;border-start-start-radius: 8px;bottom: 0px;box-sizing: border-box;caret-color: rgb(20, 20, 20);color: rgb(20, 20, 20);column-rule-color: rgb(20, 20, 20);display: flex;height: 48px;inset-block-end: 0px;inset-block-start: 0px;inset-inline-end: 0px;inset-inline-start: 0px;left: 0px;perspective-origin: 199px 24px;position: relative;right: 0px;text-decoration: none solid rgb(20, 20, 20);text-emphasis-color: rgb(20, 20, 20);text-rendering: optimizelegibility;text-size-adjust: 100%;top: 0px;transform-origin: 199px 24px;width: 100%;background: rgb(245, 245, 245) none repeat scroll 0% 0% / auto padding-box padding-box;border: 0px none rgb(20, 20, 20);border-radius: 8px;font: 14px / 20.3px Averta, -apple-system, &#39;system-ui&#39;, &#39;Segoe UI&#39;, Roboto, &#39;Helvetica Neue&#39;, Arial, sans-serif;outline: rgb(20, 20, 20) none 0px;padding: 0px 16px;">
                            <div id="backFromSearch" style="display: none" class="sn-slotWrapper_214e61"><style>.sn-slotWrapper_214e61{color:var(--color-text-primary);}
                                    .sn-slotWrapper_214e61{align-items:center;display:flex;justify-content:center;}
                                    .cc-iconWrapper_a96813{align-items:center;color:var(--color-text-secondary);display:flex;justify-content:center;}
                                    .cc-iconWrapper_a96813.cc-clickable_1c0a35{cursor:pointer;}</style><div class="cc-iconWrapper_a96813 cc-clickable_1c0a35"><svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" width="20px" height="20px"><path fill="currentColor" d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"></path></svg></div>
                            </div>
    						<div id="DIV_7" style="display: flex; flex: 1 1 0%; padding-inline-start: 16px;">
    							<input id="INPUT_8" placeholder="Αναζήτηση" type="search" style="text-align:center;background-color: rgb(245, 245, 245); block-size: 100%; border: 0px none; caret-color: rgb(20, 20, 20); font-family: Averta, -apple-system, &#39;system-ui&#39;, &#39;Segoe UI&#39;, Roboto, &#39;Helvetica Neue&#39;, Arial, sans-serif; font-size: 14px; font-weight: 400; height: 100%; inline-size: 100%; padding-block-start: 0px; padding-inline-start: 16px; outline: none; text-size-adjust: 100%; text-rendering: optimizelegibility;">
    						</div>
    					</div>
    					<div id="searchResults" style="display:none" class="sc-hFNxDb kUngdu sc-jNWZAb eyqaEJ">
    						<style>
    							*,
    							:after,
    							:before {
    								box-sizing: border-box;
    							}

    							a {
    								-webkit-text-decoration-skip: objects;
    								background-color: transparent;
    								text-decoration: none;
    							}

    							a,
    							a:hover {
    								color: inherit;
    							}

    							a:hover {
    								text-decoration: none;
    							}

    							img {
    								border-style: none;
    							}

    							.sn-overflow-ellipsis {
    								overflow: hidden;
    								text-overflow: ellipsis;
    								white-space: nowrap;
    							}

    							.cc-wrapper_e87e12 {
    								align-items: center;
    								cursor: pointer;
    								display: flex;
    							}

    							.cc-wrapper_e87e12:hover {
    								background: var(--color-background);
    							}

    							.cc-iconContainer_f77df1 {
    								align-items: center;
    								display: flex;
    								height: 42px;
    								justify-content: center;
    								width: 42px;
    							}

    							.cc-magnifier_b3de47 {
    								color: var(--color-text-secondary);
    							}

    							.cc-text_266980 {
    								border-bottom: 1px solid var(--color-divider-primary);
    								margin-left: var(--spacing-s3);
    								padding: var(--spacing-s4)0;
    								width: 100%;
    							}

    							.cc-wrapper_86669a {
    							    padding-left: 10px;
    							    border-radius: 5px;
    								align-items: center;
    								cursor: pointer;
    								display: flex;
    							}

    							.cc-wrapper_86669a:hover {
    								background: hsl(0 0% 96%);
    							}

    							.cc-logo_4faa28 {
    							    border: 1px solid lightgray;
    								border-radius: var(--shape-circle);
    								flex-shrink: 0;
    								height: 36px;
    								width: 36px;
    								margin-right: 10px;
    							}

    							.cc-info_20949c {
    								border-bottom: 1px solid var(--color-divider-primary);
    								margin-left: var(--spacing-s3);
    								min-width: 0;
    								padding: var(--spacing-s4)0;
    								width: 100%;
    							}

    							.cc-title_0cc699 {
    								width: 100%;
    							}

    							.cc-input_9ab563 {
    								font-weight: var(--font-weight-bold);
    							}

    							/*.jnzcII {*/
    							/*	padding: 0px 1rem 1rem;*/
    							/*}*/
                                
    							/*.jnzcII:first-of-type {*/
    							/*	padding-top: 0px;*/
    							/*}*/
                                
    							/*.jnzcII:not(:last-of-type) {*/
    							/*	padding-bottom: 0px;*/
    							/*}*/

    							.eyqaEJ {
    								padding-left: 1rem;
    								padding-right: 1rem;
    								padding-bottom: calc(2rem + env(safe-area-inset-bottom));
    							}
    						</style>
    						<div class="sc-ePYyCb eBDiKQ">
    							<div class="sc-fYddQe jnzcII">
    								<a class="cc-wrapper_86669a" href="/en/event/asdasd/asdasd">
    									<img class="cc-logo_4faa28" src="${vog}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Πέτρος Ιακωβίδης & Ρία Ελληνίδου</div>
                                            <span class="subtext2">VOG Club</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${barbarela}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Θοδωρής Φέρρης</div>
                                            <span class="subtext2">Barbarella</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${pyli}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Nikos Oikonomoulos</div>
                                            <span class="subtext2">Pyli A.</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${mavri_logo}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Μαύρη Θάλασσα</div>
                                            <span class="subtext2">Mavri Thalassa</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${lefki_logo}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Μπάνιο στην Λευκή</div>
                                            <span class="subtext2">Leuki Ammos beach bar</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${radiocity}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Ιφιγένεια η εν Αυλίδι</div>
                                            <span class="subtext2">Radio City Theater</span>    									
    									</div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${toumpa}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">ΠΑΟΚ - Ολυμπιακός</div>
                                            <span class="subtext2">Toumpa Stadium</span>    									
                                        </div>
    								</a>
    								<a class="cc-wrapper_86669a" href="#">
    									<img class="cc-logo_4faa28" src="${palataki}" alt="" width="36px" height="36px" style="background-blend-mode:normal!important;background-clip:content-box!important;background-position:50% 50%!important;background-color:rgba(0,0,0,0)!important;background-image:var(--sf-img-436)!important;background-size:100% 100%!important;background-origin:content-box!important;background-repeat:no-repeat!important">
    									<div class="cc-info_20949c">
    										<div class="cc-title_0cc699 sn-overflow-ellipsis">Jordan Peterson</div>
                                            <span class="subtext2">PAOK Sports Arena</span>    									
    									</div>
    								</a>
    								
    							</div>
    							
    						</div>
    					</div>
    					<div id="filtersSection" class="sc-aKXii jgfvLO swimlane-1-0-component">
    						<div class="sc-cKZHtR vDPJd">
    							<div class="sn-swimlaneWrapper_f8f9ed sn-allowOverflow_f60cf1 sc-iIEYgE heqGeJ" style="align-items: center">
    								<div class="sn-itemList_f16527" style="overflow-y:hidden;justify-content: center;/* margin-right: 0; */left: 50%;transform: translateX(-50%);">
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="drink">
    										<div class="sc-gsBpUr zZKgo">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${drinks}" loading="lazy" alt="Καφέδες" draggable="false" class="sc-ezroHd eNAoZg" style="">
    												<div class="sc-gJryjf gDBVxO">Ποτό</div>
    											</div>
    										</div>
    									</div>
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="food" style="align-items: center;justify-content: center">
    										<div class="sc-gsBpUr zZKgo" style="left: 50%">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${food}" loading="lazy" alt="Burgers" draggable="false" class="sc-ezroHd eNAoZg">
    												<div class="sc-gJryjf gDBVxO">Φαγητό</div>
    											</div>
    										</div>
    									</div>
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="events">
    										<div class="sc-gsBpUr zZKgo">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${events}" loading="lazy" alt="Σουβλάκια" draggable="false" class="sc-ezroHd eNAoZg">
    												<div class="sc-gJryjf gDBVxO">Events</div>
    											</div>
    										</div>
    									</div>
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="beach">
    										<div class="sc-gsBpUr zZKgo">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${beach}" loading="lazy" alt="Σουβλάκια" draggable="false" class="sc-ezroHd eNAoZg">
    												<div class="sc-gJryjf gDBVxO">Παραλία</div>
    											</div>
    										</div>
    									</div>
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="sports">
    										<div class="sc-gsBpUr zZKgo">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${sports}" loading="lazy" alt="Σουβλάκια" draggable="false" class="sc-ezroHd eNAoZg">
    												<div class="sc-gJryjf gDBVxO">Αθλητισμός</div>
    											</div>
    										</div>
    									</div>
    									<div class="sn-swimlaneItem_06d019" data-activatefilter="theater">
    										<div class="sc-gsBpUr zZKgo">
    											<div class="sc-irOPRQ fsIyEp standard">
    												<img src="${theater}" loading="lazy" alt="Σουβλάκια" draggable="false" class="sc-ezroHd eNAoZg">
    												<div class="sc-gJryjf gDBVxO">Θέατρο</div>
    											</div>
    										</div>
    									</div>
    								</div>
    							</div>
    						</div>
    					</div>
    					<div id="eventsSection" class="sc-ljRaSg gmSNZM list-1-0-component" style=" justify-items: center;  justify-content: center;display:grid;    grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));">
    						<div class="sc-bGqOnq ikbUXi" data-filters="drink">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="/en/event/asdasd/asdasd">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy" alt="Σουβλάκια" src="${petros}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 VOG Club</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Πέτρος Ιακωβίδης &amp; Ρία Ελληνίδου</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα σημερα</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 255€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 100px">Άφιξη έως</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">00:15</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="drink">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${feris}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Barbarella</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Θοδωρής Φέρρης</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα αυριο</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 155€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Άφιξη έως</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">00:15</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="drink">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${oikonomopoulos}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Pyli A.</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Nikos Oikonomoulos</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Άφιξη έως</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">00:15</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="food">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${mavri}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Mavri Thalassa</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Μαύρη Θάλασσα</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Κρατήσεις ανά</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">2 ώρες</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="beach">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${lefki}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Leuki Ammos beach bar </span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Μπάνιο στην Λευκή </h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Άφιξη έως</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">11:30</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="theater">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${ifigenia}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Radio City Theater</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Ιφιγένεια η εν Αυλίδι</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Απομένουν</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">3 θέσεις</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="sports">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${paok}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 Toumpa Stadium</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">ΠΑΟΚ - Ολυμπιακός</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Απομένουν</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">230 θέσεις</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    						<div class="sc-bGqOnq ikbUXi" data-filters="events">
    							<div class="cc-wrapper_de1daf cc-image_35061e card-1-0-shop">
    								<a class="cc-inner_a8a37d" href="#">
    									<div class="cc-imageCoverWrapper_7d776f">
    										<img class="cc-cover_e519a2 lazyloaded" loading="lazy"   alt="Σουβλάκια" src="${peterson}">
    										<div class="cc-deliveryCost_e902e7">
    											<span class="cc-deliveryCostPrice_6cf03d">📍 PAOK Sports Arena</span>
    										</div>
    									</div>
    									<div class="cc-shopItemWrapper_4ce69c cc-image_35061e">
    										<div class="cc-infoWrapper_73e83c">
    											<div class="cc-info_27ca9b">
    												<h3 class="cc-title_6a7783 sn-overflow-ellipsis">Jordan Peterson</h3>
    												<span class="">
    													<span class="subtext1">Διαθεσιμοτητα 13/6/2026</span>
    													<span class="subtext2 hasBullet">Ελάχιστη 355€</span>
    												</span>
    											</div>
    										</div>
    										<div class="cc-ratingWrapper_239e98">
    											<div class="subtext2" style="text-align: right;width: 130px">Απομένουν</div>
    											<div class="cc-rating_735e91">
    												<span class="subtext3">16 θέσεις</span>
    											</div>
    										</div>
    									</div>
    								</a>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </div>
    <div id="navigationBar" class="sc-fZOUJb conWMH">
    	<style>
    		/*! CSS Used from: Embedded */
    		*,
    		:after,
    		:before {
    			box-sizing: border-box;
    		}

    		.sn-overflow-ellipsis {
    			overflow: hidden;
    			text-overflow: ellipsis;
    			white-space: nowrap;
    		}

    		.cc-wrapper_9babfd {
    			align-items: center;
    			display: flex;
    			flex-direction: column;
    			height: 100%;
    			justify-content: space-around;
    			margin: 0 var(--spacing-s2);
    			min-width: 0;
    			padding: 0 var(--spacing-s3);
    			position: relative;
    		}

    		.cc-wrapper_9babfd:hover {
    			cursor: pointer;
    		}

    		.cc-label_b4f792 {
    			font-size: var(--font-size-s1);
    			max-width: 100%;
    		}

    		.cc-wrapper_9babfd:after {
    			background-color: transparent;
    			border: var(--spacing-s1) solid transparent;
    			border-radius: var(--shape-rounded-s0);
    			content: "";
    			left: 0;
    			position: absolute;
    			top: 0;
    			width: 100%;
    		}

    		.cc-wrapperActive_669bbb:after {
    			background-color: var(--color-surface-secondary);
    			border-color: var(--color-surface-secondary);
    		}

    		.cc-wrapper_f06cbe {
    			background-color: var(--color-surface);
    			box-shadow: 0-2px 4px 0 rgba(0, 0, 0, .08);
    			height: var(--spacing-s10);
    		}

    		.cc-wrapper_f06cbe {
    			align-items: center;
    			display: flex;
    			justify-content: center;
    		}

    		/*! CSS Used from: Embedded */
    		.conWMH {
    			width: 100%;
    			position: fixed;
    			bottom: 0px;
    			left: 0px;
    			animation: 0.3s ease-in-out 0s 1 normal none running crmfwB;
    			padding-bottom: env(safe-area-inset-bottom);
    			background-color: rgb(255, 255, 255);
    			z-index: 1030;
    		}
    	</style>
    	<div class="cc-wrapper_f06cbe">
    		<a href="/en" class="cc-wrapper_9babfd cc-wrapperActive_669bbb cc-wrapperContainer">
    			<div class="icon-container">
    				<img class="cc-navigationIcon_763ff2" src="${nav_search}">
    			</div>
    			<div class="sn-overflow-ellipsis cc-label_b4f792">Αναζήτηση</div>
    		</a>
    		<div class="cc-wrapper_9babfd cc-wrapperContainer" >
    			<div class="icon-container">
    				<img class="cc-navigationIcon_763ff2" src="${nav_basket}">
    				<span class="cc-badge">3</span>
    			</div>
    			<div class="sn-overflow-ellipsis cc-label_b4f792">Καλάθι</div>
    		</div>
    		<div class="cc-wrapper_9babfd cc-wrapperContainer">
    			<div class="icon-container">
    				<img class="cc-navigationIcon_763ff2" src="${nav_tickets}">
    			</div>
    			<div class="sn-overflow-ellipsis cc-label_b4f792">Κρατήσεις</div>
    		</div>
    	</div>
    </div>
`;

HomeContainer.reg('home-container');
